class CollapsibleFooter extends Collapsible {
  constructor() {
    super();
    if (!this.options.breakpoint) {
      this.options.breakpoint = parseInt(768);
    }
    this.windowWidth = window.innerWidth;
    this.displayDetails();
  }

  construct() {
    super.construct();

    window.addEventListener('resize', (e) => {
      this.windowWidth = window.innerWidth;
      this.displayDetails();
    });
  }

  open(group) {
    if (window.innerWidth < this.options.breakpoint) {
      super.open(group);
    }
  }

  close(group) {
    if (window.innerWidth < this.options.breakpoint) {
      super.close(group);
    }
  }

  displayDetails() {
    if (window.innerWidth >= this.options.breakpoint) {
      this.openAll();
    } else {
      this.closeAll();
    }
  }

}

if (!customElements.get('collapsible-footer')) {
  customElements.define('collapsible-footer', CollapsibleFooter);
}

class AnimatedFooter extends HTMLElement {
  constructor() {
    super();

    // load event
    window.addEventListener('load', this.hideFooterBottom.bind(this), false);

    // scroll event
    window.addEventListener('scroll', this.hideFooterBottom.bind(this), false);

     // resize event
    window.addEventListener('resize', this.hideFooterBottom.bind(this), false);


    // get footer wrapper
    this.footerWrapper = this.closest('.section-footer');

    // show footer bottom when mouse entered
    this.footerWrapper.addEventListener('mouseenter', e => {
      this.footerWrapper.classList.add('show');
    });

    // hide footer bottom when mouse left
    this.footerWrapper.addEventListener('mouseleave', e => {
      this.footerWrapper.classList.remove('show');
    });

  }

  hideFooterBottom() {

    const footerBottom = document.querySelector('[data-footer-bottom]');
    const footerBottomHeight = footerBottom.offsetHeight;
    const bodyHeight = document.body.scrollHeight - footerBottomHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    // add class to the body when scroller reaches the footer
    if (window.pageYOffset + window.innerHeight >= bodyHeight) {
      document.body.classList.add('footer-reached');
    } else {
      document.body.classList.remove('footer-reached');
    }

    // hide footerbottom when scrolling
    if (viewportWidth >= 1024) {
      this.footerWrapper.style.bottom = `-${footerBottomHeight}px`;
    }

  }

}

if (!customElements.get('animated-footer')) {
  customElements.define('animated-footer', AnimatedFooter);
}